import { SecondaryTranslation } from "types";
import { routesEn } from "./strings.routes.en";

export const routesHi: SecondaryTranslation<typeof routesEn> = {
  routes_Dashboard_OnboardingEntriesPage: "अपनी एन्ट्री चुनें",
  routes_Dashboard_OnboardingSubscriptionPage: "सदस्यता चुनें",
};
